import { Colors } from '@sigma-frontend-libs/commons'

import { components, services } from '@/utils'

import formatTable from '@/components/format/table'
import preloader from '@/components/preloader'
import detailsItem from '@/components/services/sendings/outgoing/details/item'
import tag from '@/components/tag'

function renderType(h, type) {
  return h(
    tag,
    {
      props: {
        color: Colors[type],
        label: type
      }
    }
  )
}
function renderSentStatus(h, status) {
  let sentStatusColor = Colors.success
  let sentStatusKey = 'sent'
  if (status === undefined) {
    sentStatusColor = Colors.grey
    sentStatusKey = 'notSent'
  }

  return h(
    tag,
    {
      props: {
        color: sentStatusColor,
        label: this.getTranslate(`${services.sendings}.fallbacks.sentStatus.${sentStatusKey}`)
      }
    }
  )
}
function renderItemHeader(h, item) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-fallbacks-item__header`
    },
    [
      renderSentStatus.call(this, h, item.state?.status),
      renderType.call(this, h, item.type)
    ]
  )
}
function renderFormatTable(h, item) {
  return h(
    formatTable,
    {
      props: {
        value: { $options: item.$options },
        service: services.sendingsFallbacks
      }
    }
  )
}
function renderSending(h, item) {
  if (item.id) {
    return h(
      detailsItem,
      {
        props: {
          value: item,
          panelProps: {
            outline: true,
            rounded: true
          }
        }
      }
    )
  }
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-fallbacks-item`
    },
    [
      renderItemHeader.call(this, h, item),
      renderFormatTable.call(this, h, item),
      renderSending.call(this, h, item)
    ]
  )
}

function renderNotSentItems(h) {
  if (Array.isArray(this.itemsWithoutId) && this.itemsWithoutId.length) {
    return h(
      'div',
      {
        class: `${services.sendings}-item__tabs-fallbacks-items`
      },
      [
        this.itemsWithoutId.map(item => {
          return renderItem.call(this, h, item)
        })
      ]
    )
  }
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder preloader__holder--absolute pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderSentItems(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-fallbacks-items`
    },
    [
      this.items.map(item => {
        return renderItem.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderSentItemsBody(h) {
  if (Array.isArray(this.items) && this.items.length) {
    return renderSentItems.call(this, h)
  } else {
    switch (this.loading) {
      case true: return renderPreloader.call(this, h)
      case false:
      default: {
        if (this.itemsWithoutId.length === 0) {
          return h(components.empty)
        }
      }
    }
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-fallbacks`
    },
    [
      renderNotSentItems.call(this, h),
      renderSentItemsBody.call(this, h)
    ]
  )
}
